<template>
    <div style="width: 100%; height: 100%">
        <div ref="mapDiv" style="width: 100%; height: 100%"></div>
    </div>
</template>

<script>
import { $WC, $NM} from '@/conf/common.const.js';

export default {
    name: 'NaverMap',
    props: {
        propOptions: {},
        propAddongCd: ""
    },
    data() {
        return {
            map: {},
            options: {},
            viewScale: 1,
            mapTileSize: 256 * $NM.TILE_SIZE_SCALE,
            mapTypeId: naver.maps.MapTypeId.NORMAL,
            addongList: [],
            selectedAddongCd: $WC.guCode,
            isMounted: false,
        };
    },
    computed: {
        Map_TYPE_NORMAL() {
            return naver.maps.MapTypeId.NORMAL;
        },
        Map_TYPE_SATELLITE() {
            return naver.maps.MapTypeId.SATELLITE;
        },
        addongMap() {
            let dongMap = {};
            for(let i in this.addongList) {
                dongMap[this.addongList[i].addongCd] = this.addongList[i];
            }
            return dongMap;
        }
    },
    mounted() {
        let defaultOptions = {
            lat: $WC.localGovLatitude,      // 위도
            lng: $WC.localGovLongitude,     // 경도
            zoom: 13,                       // 지도의 초기 줌 레벨
            maxZoom: 12,                    // 지도의 최대 줌 레벨
            minZoom: 12,                    // 지도의 최소 줌 레벨
            zoomControl: false,             // 줌 컨트롤의 표시 여부
            zoomControlOptions: {
                // 줌 컨트롤의 옵션
                position: naver.maps.Position.TOP_RIGHT
            },
            mapTypeControl: false,  // 지도 타입 컨트롤러 사용여부 (위성/지도)
            scaleControl: false,    // 축적 표시여부
            mapDataControl: false   // 지도 데이터 유형 표시여부
        };

        if(this.propOptions == undefined) {
            this.options = defaultOptions;
        } else {
            this.options = jQuery.extend(true, defaultOptions, this.propOptions);
        }

        let tileSize = [this.mapTileSize * this.viewScale, this.mapTileSize * this.viewScale];
        let registry = new naver.maps.MapTypeRegistry();

        registry.set(this.Map_TYPE_NORMAL, naver.maps.NaverStyleMapTypeOption.getNormalMap({
            hd: true,
            tileSize: tileSize
        }));

        registry.set(this.Map_TYPE_SATELLITE, naver.maps.NaverStyleMapTypeOption.getSatelliteMap({
            hd: true,
            tileSize: tileSize
        }));

        this.map = new naver.maps.Map(this.$refs.mapDiv, {
            useStyleMap: true,
            center: new naver.maps.LatLng(this.options.lat, this.options.lng), //지도의 초기 중심 좌표
            zoomControl: this.options.zoomControl,
            zoom: this.options.zoom,
            mapTypeId: this.mapTypeId,
            mapTypes: registry
        });

        let listener = naver.maps.Event.addListener(this.map, 'tilesloaded', () => {
            naver.maps.Event.removeListener(listener);
            this.$eventBus.$emit('NaverMap::map-loaded', this.map);
        });
    }
}
</script>
